'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { Moon, Sun, Airplay } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useLayoutEffect, useState } from 'react';
import { cn } from '../../utils/cn';
const itemVariants = cva('size-7 rounded-full p-1.5 text-fd-muted-foreground', {
    variants: {
        active: {
            true: 'bg-fd-accent text-fd-accent-foreground',
            false: 'text-fd-muted-foreground',
        },
    },
});
export function ThemeToggle({ className, mode = 'light-dark', ...props }) {
    const { setTheme, theme, resolvedTheme } = useTheme();
    const [mounted, setMounted] = useState(false);
    useLayoutEffect(() => {
        setMounted(true);
    }, []);
    const container = cn('inline-flex items-center rounded-full border p-[3px]', className);
    if (mode === 'light-dark') {
        const value = mounted ? resolvedTheme : null;
        return (_jsxs("button", { className: container, onClick: () => setTheme(value === 'light' ? 'dark' : 'light'), "data-theme-toggle": "", ...props, children: [_jsx(Sun, { className: cn(itemVariants({ active: value === 'light' })) }), _jsx(Moon, { className: cn(itemVariants({ active: value === 'dark' })) })] }));
    }
    const value = mounted ? theme : null;
    return (_jsx("div", { className: container, "data-theme-toggle": "", ...props, children: [
            ['light', Sun],
            ['dark', Moon],
            ['system', Airplay],
        ].map(([key, Icon]) => (_jsx("button", { "aria-label": key, className: cn(itemVariants({ active: value === key })), onClick: () => setTheme(key), children: _jsx(Icon, { className: "size-full" }) }, key))) }));
}
